import { Injectable } from "@angular/core";

const localStorageUsername = "adrentech_timetracking_username";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  constructor() {}
  rememberUserName(username: string) {
    localStorage.setItem(localStorageUsername, username);
  }
  forgetUserName() {
    localStorage.removeItem(localStorageUsername);
  }
  getRememberedUserName() {
    return localStorage.getItem(localStorageUsername);
  }
  set(name: string, value: string, options: IStorageOptions = {}) {
    options = {
      path: "/",
      ...options,
    };

    let updatedCookie =
      encodeURIComponent(name) + "=" + encodeURIComponent(value);

    if (options.path) {
      updatedCookie += `; path=${options.path}`;
    }
    if (options.domain) {
      updatedCookie += `; domain=${options.domain}`;
    }
    if (options["max-age"]) {
      updatedCookie += `; max-age=${options["max-age"]}`;
    }
    if (options.expires) {
      updatedCookie += `; expires=${options.expires.toUTCString()}`;
    }
    if (options.samesite) {
      updatedCookie += `; samesite=${options.samesite}`;
    }
    if (options.secure) {
      updatedCookie += "; secure";
    }
    document.cookie = updatedCookie;
  }
  get(name) {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
  remove(name: string) {
    this.set(name, "", { "max-age": -1 });
  }
}

export interface IStorageOptions {
  path?: string;
  domain?: string;
  expires?: Date;
  ["max-age"]?: number;
  secure?: boolean;
  samesite?: string;
}
